module.exports = __webpack_public_path__ + "img/scan (12).56d569f8.png";